var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 305.46 68.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05D3\\u05E3_\\u05D4\\u05D1\\u05D9\\u05EA",
    "data-name": "\\u05D3\\u05E3 \\u05D4\\u05D1\\u05D9\\u05EA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.76,21.18H3.36v-9.18h27.72v36h-10.32v-26.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.94,12h10.32v19.68h-10.32V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.58,49.14c-5.1,0-10.74-2.34-14.34-6.78l6.96-6.06c1.68,2.04,4.44,3.36,6.66,3.36,5.1,0,9-4.02,9-9.66s-3.9-9.66-9-9.66c-2.22,0-4.98,1.32-6.66,3.36l-6.96-6.06c3.6-4.44,9.24-6.78,14.34-6.78,11.28,0,18.54,8.16,18.54,19.14s-7.26,19.14-18.54,19.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.28,21.18h-23.34v-9.18h33.66v36h-10.32v-26.82ZM93.36,28.38h10.32v19.62h-10.32v-19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.08,6.6h10.32v5.4h21.24l-15.54,37.02-9.42-3.78,10.2-24.06h-16.8V6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222,12v36h-35.04V12h35.04ZM211.68,38.82v-17.64h-14.4v17.64h14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.86,12h10.32v19.68h-10.32V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.2,12v36h-35.04v-9.18h6.66V12h10.32v26.82h7.74V12h10.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.34,38.82V12h10.26l.06,36h-20.04v-9.18h9.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/נעים להכירmdpi.a2624009a88cf3f53465782c9fa06508.svg";
export { ForwardRef as ReactComponent };